import React from "react";

class UserCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = { checked: this.props.select };
        this.handleCheck = this.handleCheck.bind(this);
    }

    handleCheck(e){
        this.setState({
            checked: e.target.checked
        })
    }
    render(){
        return (
            <div className="checkbox">
                <label><input
                    type="checkbox"
                    name="departmentList"
                    checked={this.state.checked}
                    onChange={this.handleCheck}
                    value={this.props.value}
                /> {this.props.text}</label>
            </div>
        );
    }
}


export default UserCheckbox;